<mat-form-field class="w-100" (click)="listDistricts()">
  <mat-label>Seleccione distrito</mat-label>
  <input matInput id="codeUbigeo" [formControl]="district" [matAutocomplete]="auto">
  <button type="button" mat-icon-button matSuffix *ngIf="district.value">
    <mat-icon class="clear" (click)="resetForm()" matTooltip="Borrar">highlight_off</mat-icon>
  </button>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="emitEvent()" [displayWith]="displayFn">
    <mat-option *ngFor="let option of filteredDistrict | async" [value]="option" [id]="option['id'].toString()">
      {{option ? option.district: ''}} -
      <small>{{option ? option.province : '' }}</small> -
      <small>{{option ? option.department : '' }}</small>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>